import BaseModel from '../base/BaseModel.model';
import User from '../security/user.model';
import { EvaluationState } from '@/enums/EvaluationState';

export default class UserEvaluationState extends BaseModel {

    public evaluator: User | null = null;
    public evaluationState: EvaluationState = null;
    public isApproved: boolean = false;
    
    constructor(){
        super();
        this.init();
    }

    init(){}
}